module.exports = __webpack_public_path__ + "static/media/loginBanner.ff31f6d2.jpg";